import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=8bccbaa4&scoped=true&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessage.vue?vue&type=style&index=0&id=8bccbaa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bccbaa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bccbaa4')) {
      api.createRecord('8bccbaa4', component.options)
    } else {
      api.reload('8bccbaa4', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=8bccbaa4&scoped=true&", function () {
      api.rerender('8bccbaa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/sp/ErrorMessage.vue"
export default component.exports